import { render } from "./RiQuestion.vue?vue&type=template&id=18ba81b3"
import script from "./RiQuestion.vue?vue&type=script&lang=js"
export * from "./RiQuestion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiQuestion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18ba81b3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18ba81b3', __exports__)) {
    api.reload('18ba81b3', __exports__)
  }
  
  module.hot.accept("./RiQuestion.vue?vue&type=template&id=18ba81b3", () => {
    api.rerender('18ba81b3', render)
  })

}


export default __exports__